<div class="admin containerView" *ngIf="variant =='REQUEST'">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-breadcrum [breadcrums]="breadcrums"></app-breadcrum>
      </div>
      <div style="width: 100%;">
        <app-license-detail [requirementId]="id" [shouldShowPersonalData]="true" [shouldShowDocumentLinks]="showDocumentsLinks"
          (goBack)="onGoBack()">
        </app-license-detail>
      </div>
    </div>
  </div>
</div>

<div class="admin containerView" *ngIf="variant =='LICENSE'">
  <div class="container">
    <div class="row">
      <div style="width: 100%;">
        <app-license-detail
          *ngIf="licenseData"
          [shouldShowPersonalData]="true"
          [shouldShowFlow]="false"
          [shouldShowRequestNumberTitle]="false"
          [shouldShowDocumentLinks]="showDocumentsLinks"

          [shouldShowLicenseSection]="true"
          [licenseNumber]="licenseData.licenseNumber"
          [licenseId]="licenseData.id"
          [restrictions]="licenseData.asset.drivingRestriction"

          [gettingDataRequirement]="licenseDataGetting"
          [getDetailsError]="licenseDataError"
          [equipments]="equipments"
          [documents]="documents"
          [assetId]="licenseData.asset.id"

          [personRutDv]="personRutDv"
          [requirementId]="licenseData.requirementId"
          (goBack)="onGoBack()"
        >
        </app-license-detail>
      </div>
    </div>
  </div>
</div>
